"use client";

import { useReducedMotion } from "motion/react";
import "./octagon-badge-surfaces.css";

interface SkillBadgeShineProps {
	direction: "forward" | "reverse";
}

/**
 * Diagonal shimmer — transitions from its current position (45° top-left → bottom-right).
 */
export function SkillBadgeShine({ direction }: SkillBadgeShineProps) {
	const reduceMotion = useReducedMotion();

	if (reduceMotion) {
		return null;
	}

	return (
		<div
			aria-hidden
			className="sq-skill-badge-shine-band"
			data-direction={direction}
		/>
	);
}
